import React, {useEffect, useState} from 'react';
import {Button, Card, Divider, Drawer, FloatButton, Form, Input, message, Modal, Space, Tooltip} from "antd";
import {CopyOutlined, FileOutlined, FolderOutlined, MinusCircleOutlined, PlusOutlined, ReloadOutlined} from '@ant-design/icons';
import {EditOutlined, DeleteOutlined, DragOutlined, ClearOutlined,SelectOutlined} from '@ant-design/icons';
import dayjs from "dayjs";
import Cookies from "js-cookie";
import {useNavigate} from "react-router-dom";
import './moban.css';


const Admin_moban_ui=()=>{

const navigate=useNavigate();

    function extractVariables(template: string): string[] {
        const regex = /\$\{([a-zA-Z_]\w*)\}/g;
        const vars = new Set<string>();
        let match;


        while ((match = regex.exec(template)) !== null) {
            vars.add(match[1]);
        }

        return Array.from(vars);
    }

    useEffect(() => {


        setfetch_moban_select_log({message:'11',value:'',time:data_time})

    }, []);
    const data_time=dayjs().unix();
    const [select_message_modal_open, setselect_message_modal_open] = useState(false)

    const [select_message_select_info, setselect_message_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [select_message_select_log, setselect_message_select_log] = useState({message: '', value: '', time: 0})
    const select_message = (e1: any) => {

        setselect_message_select_log({message: 'click', value: '', time: data_time})

        setselect_message_modal_open(true);

        setselect_message_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setselect_message_modal_oncancel = () => {

        setselect_message_modal_open(false);
    }


    const [select_message_modal_form]=Form.useForm();

    const select_message_modal_initialValues={




    }

    const [select_message_modal_onfinish_select_log,setselect_message_modal_onfinish_select_log]=useState({message:'',value:'',time:0})

    const [select_message_modal_onfinish_select_info,setselect_message_modal_onfinish_select_info]=useState({value1:'',value2:'',value3:'',time:0});

    const select_message_modal_onfinish = (e1:any) => {

        let data_time=dayjs().unix();

        setselect_message_modal_onfinish_select_log({message:'next_button',value:'',time:data_time})
        setselect_message_modal_onfinish_select_info({value1:e1,value2:'',value3:'',time:data_time})
    }


    const [return_data_select_message,setreturn_data_select_message]=useState({});

    const select_message_body = new FormData();


    select_message_body.append('finish_data', JSON.stringify(select_message_modal_onfinish_select_info.value1));

    select_message_body.append('userToken', String(Cookies.get('userToken_chattool')));

    select_message_body.append('time', String(select_message_modal_onfinish_select_info.time));

    select_message_body.append('action', 'add_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('undefined', {


                method: 'POST',
                body: select_message_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    //message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setselect_message_modal_open(false)

                    setreturn_data_select_message(return_data);
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/moban')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/moban')


                    break


            }

        }


        if(select_message_modal_onfinish_select_log.message!==''){

            data_async();
            setselect_message_modal_onfinish_select_log({message:'',value:'',time:0})
        }
    }, [select_message_modal_onfinish_select_log]);






    const [fetch_moban_select_info, setfetch_moban_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [fetch_moban_select_log, setfetch_moban_select_log] = useState({message: '', value: '', time: 0})
    const fetch_moban = (e1: any) => {

        setfetch_moban_select_log({message: 'click', value: '', time: data_time})



        setfetch_moban_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_fetch_moban,setreturn_data_fetch_moban]=useState({
        "message": 2000,
        "value": "获取成功",
        "info": [
            {
                "id": "1",
                "uuid": "11",
                "title": "模板1",
                "value": null,
                "cretated": 0,
                "status": "en",
                "country_uuid": "341eea77-f9ef-4157-a695-05c0f9b70761"
            }
        ]
    });


    const [moban_value, setmoban_value] = useState<string[]>([]);

    const fetch_moban_body = new FormData();


    fetch_moban_body.append('id', fetch_moban_select_info.value1);

    fetch_moban_body.append('userToken', String(Cookies.get('userToken_chattool')));

    fetch_moban_body.append('time', String(fetch_moban_select_info.time));

    fetch_moban_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/moban/fetch/fetch_moban.php', {


                method: 'POST',
                body: fetch_moban_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    //message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setreturn_data_fetch_moban(return_data);


                    //setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/moban')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/moban')


                    break


            }

        }


        if(fetch_moban_select_log.message!==''){

            data_async();
            setfetch_moban_select_log({message:'',value:'',time:0})
        }
    }, [fetch_moban_select_log]);

const[old_value,setold_value]=useState('')
    const use_d=(value:any)=>{

    setinit_d_finish('')

        select_message_modal_form.setFieldValue('input_value1',value)
setold_value(value)
        const result = extractVariables(value);

setmoban_value(result)
        console.log(value)
        console.log(result);


setmarg_moban_modal_open(false)
    }



    const [send_bianliang_modal_open, setsend_bianliang_modal_open] = useState(false)

    const [send_bianliang_select_info, setsend_bianliang_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [send_bianliang_select_log, setsend_bianliang_select_log] = useState({message: '', value: '', time: 0})
    const send_bianliang = (e1: any) => {

        setsend_bianliang_select_log({message: 'click', value: '', time: data_time})

        setsend_bianliang_modal_open(true);

        setsend_bianliang_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setsend_bianliang_modal_oncancel = () => {

        setsend_bianliang_modal_open(false);
    }


    const [send_bianliang_modal_form]=Form.useForm();

    const send_bianliang_modal_initialValues={




    }

    const [send_bianliang_modal_onfinish_select_log,setsend_bianliang_modal_onfinish_select_log]=useState({message:'',value:'',time:0})

    const [send_bianliang_modal_onfinish_select_info,setsend_bianliang_modal_onfinish_select_info]=useState({value1:'',value2:'',value3:'',time:0});


    const [init_d_finish,setinit_d_finish]=useState('');

    const send_bianliang_modal_onValuesChange=(e1:any,e2:any)=>{

        console.log(e2)
        const result = parseTemplate(old_value,e2)
        setinit_d_finish(result)
        console.log(result)

        let data_time=dayjs().unix();

        setsend_bianliang_modal_onfinish_select_log({message:'next_button',value:'',time:data_time})
        setsend_bianliang_modal_onfinish_select_info({value1:e1,value2:'',value3:'',time:data_time})

    }
    const send_bianliang_modal_onfinish = (e1:any) => {



        setsend_bianliang_modal_onfinish_select_log({message:'next_button',value:'',time:data_time})
        setsend_bianliang_modal_onfinish_select_info({value1:e1,value2:'',value3:'',time:data_time})
    }


    const [return_data_send_bianliang,setreturn_data_send_bianliang]=useState({});

    const send_bianliang_body = new FormData();


    send_bianliang_body.append('finish_data', JSON.stringify(send_bianliang_modal_onfinish_select_info.value1));

    send_bianliang_body.append('userToken', String(Cookies.get('userToken_codegenerate')));

    send_bianliang_body.append('time', String(send_bianliang_modal_onfinish_select_info.time));

    send_bianliang_body.append('action', 'add_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('undefined', {


                method: 'POST',
                body: send_bianliang_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    //message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setsend_bianliang_modal_open(false)

                    setreturn_data_send_bianliang(return_data);
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/moban')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/moban')


                    break


            }

        }


        if(send_bianliang_modal_onfinish_select_log.message!==''){

            data_async();
            setsend_bianliang_modal_onfinish_select_log({message:'',value:'',time:0})
        }
    }, [send_bianliang_modal_onfinish_select_log]);


    function parseTemplate(template:any, variables:any) {
        // 使用正则匹配 ${...} 并替换为变量对象中的
        return template.replace(/\$\{(\w+)\}/g, (match:any, key:any) => {
            return key in variables ? variables[key] : match;
        });
    }


    const [create_moban_modal_open, setcreate_moban_modal_open] = useState(false)

    const [create_moban_select_info, setcreate_moban_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [create_moban_select_log, setcreate_moban_select_log] = useState({message: '', value: '', time: 0})
    const create_moban = (e1: any) => {

        setcreate_moban_select_log({message: 'click', value: '', time: data_time})

        setcreate_moban_modal_open(true);

        setcreate_moban_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setcreate_moban_modal_oncancel = () => {

        setcreate_moban_modal_open(false);
    }


    const [create_moban_modal_form]=Form.useForm();

    const create_moban_modal_initialValues={




    }

    const [create_moban_modal_onfinish_select_log,setcreate_moban_modal_onfinish_select_log]=useState({message:'',value:'',time:0})

    const [create_moban_modal_onfinish_select_info,setcreate_moban_modal_onfinish_select_info]=useState({value1:'',value2:'',value3:'',time:0});

    const create_moban_modal_onfinish = (e1:any) => {

        let data_time=dayjs().unix();

        setcreate_moban_modal_onfinish_select_log({message:'next_button',value:'',time:data_time})
        setcreate_moban_modal_onfinish_select_info({value1:e1,value2:'',value3:'',time:data_time})
    }


    const [return_data_create_moban,setreturn_data_create_moban]=useState({});

    const create_moban_body = new FormData();


    create_moban_body.append('finish_data', JSON.stringify(create_moban_modal_onfinish_select_info.value1));

    create_moban_body.append('userToken', String(Cookies.get('userToken_chattool')));

    create_moban_body.append('time', String(create_moban_modal_onfinish_select_info.time));

    create_moban_body.append('action', 'add_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/moban/insert/insert_create_moban.php', {


                method: 'POST',
                body: create_moban_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    //message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setcreate_moban_modal_open(false)

                    setreturn_data_create_moban(return_data);
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})
                    setfetch_moban_select_log({message:'11',value:'',time:data_time})
                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/moban')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/moban')


                    break


            }

        }


        if(create_moban_modal_onfinish_select_log.message!==''){

            data_async();
            setcreate_moban_modal_onfinish_select_log({message:'',value:'',time:0})
        }
    }, [create_moban_modal_onfinish_select_log]);


    const [edit_moban_modal_open, setedit_moban_modal_open] = useState(false)

    const [edit_moban_select_info, setedit_moban_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [edit_moban_select_log, setedit_moban_select_log] = useState({message: '', value: '', time: 0})
    const edit_moban = (uuid:any,title:any,value:any,cretated:any) => {

        edit_moban_modal_form.setFieldValue('title', title)
        edit_moban_modal_form.setFieldValue('value', value)
        setedit_moban_select_log({message: 'click', value: '', time: data_time})

        setedit_moban_modal_open(true);

        setedit_moban_select_info({value1: uuid, value2: 'title', value3: 'value', time: data_time})
    }


    const setedit_moban_modal_oncancel = () => {

        setedit_moban_modal_open(false);
    }


    const [edit_moban_modal_form]=Form.useForm();

    const edit_moban_modal_initialValues={




    }

    const [edit_moban_modal_onfinish_select_log,setedit_moban_modal_onfinish_select_log]=useState({message:'',value:'',time:0})

    const [edit_moban_modal_onfinish_select_info,setedit_moban_modal_onfinish_select_info]=useState({value1:'',value2:'',value3:'',time:0});

    const edit_moban_modal_onfinish = (e1:any) => {

        let data_time=dayjs().unix();

        setedit_moban_modal_onfinish_select_log({message:'next_button',value:'',time:data_time})
        setedit_moban_modal_onfinish_select_info({value1:e1,value2:'',value3:'',time:data_time})
    }


    const [return_data_edit_moban,setreturn_data_edit_moban]=useState({});

    const edit_moban_body = new FormData();


    edit_moban_body.append('finish_data', JSON.stringify(edit_moban_modal_onfinish_select_info.value1));
    edit_moban_body.append('uuid', edit_moban_select_info.value1);
    edit_moban_body.append('userToken', String(Cookies.get('userToken_chattool')));

    edit_moban_body.append('time', String(edit_moban_modal_onfinish_select_info.time));

    edit_moban_body.append('action', 'add_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/moban/update/update_moban.php', {


                method: 'POST',
                body: edit_moban_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    //message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setedit_moban_modal_open(false)

                    setreturn_data_edit_moban(return_data);
                    setfetch_moban_select_log({message:'1',value:'',time:data_time})
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/moban')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/moban')


                    break


            }

        }


        if(edit_moban_modal_onfinish_select_log.message!==''){

            data_async();
            setedit_moban_modal_onfinish_select_log({message:'',value:'',time:0})
        }
    }, [edit_moban_modal_onfinish_select_log]);




    const [del_moban_modal_open, setdel_moban_modal_open] = useState(false)

    const [del_moban_select_info, setdel_moban_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [del_moban_select_log, setdel_moban_select_log] = useState({message: '', value: '', time: 0})
    const del_moban = (e1: any) => {

        setdel_moban_select_log({message: 'click', value: '', time: data_time})

        setdel_moban_modal_open(true);

        setdel_moban_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setdel_moban_modal_oncancel = () => {

        setdel_moban_modal_open(false);
    }


    const [del_moban_modal_next_button_select_log,setdel_moban_modal_next_button_select_log]=useState({message:'',value:'',time:0})

    const del_moban_modal_next_button = () => {

        let data_time=dayjs().unix();

        setdel_moban_modal_next_button_select_log({message:'next_button',value:'',time:data_time})

    }


    const [return_data_del_moban,setreturn_data_del_moban]=useState({});

    const del_moban_body = new FormData();


    del_moban_body.append('uuid', del_moban_select_info.value1);

    del_moban_body.append('userToken', String(Cookies.get('userToken_chattool')));

    del_moban_body.append('time', String(del_moban_modal_next_button_select_log.time));

    del_moban_body.append('action', 'del_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/moban/delete/delete_moban.php', {


                method: 'POST',
                body: del_moban_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    //message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setdel_moban_modal_open(false)

                    setreturn_data_del_moban(return_data);
                    //setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})
                    setfetch_moban_select_log({message:'11',value:'',time:data_time})
                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/moban')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/moban')


                    break

            }

        }


        if(del_moban_modal_next_button_select_log.message!==''){

            data_async();
            setdel_moban_modal_next_button_select_log({message:'',value:'',time:0})
        }
    }, [del_moban_modal_next_button_select_log]);




    const [marg_moban_modal_open, setmarg_moban_modal_open] = useState(false)

    const [marg_moban_select_info, setmarg_moban_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [marg_moban_select_log, setmarg_moban_select_log] = useState({message: '', value: '', time: 0})
    const marg_moban = (e1: any) => {

        setmarg_moban_select_log({message: 'click', value: '', time: data_time})

        setmarg_moban_modal_open(true);

        setmarg_moban_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setmarg_moban_modal_oncancel = () => {

        setmarg_moban_modal_open(false);
    }


    const [marg_moban_modal_form]=Form.useForm();

    const marg_moban_modal_initialValues={




    }

    const [marg_moban_modal_onfinish_select_log,setmarg_moban_modal_onfinish_select_log]=useState({message:'',value:'',time:0})

    const [marg_moban_modal_onfinish_select_info,setmarg_moban_modal_onfinish_select_info]=useState({value1:'',value2:'',value3:'',time:0});

    const marg_moban_modal_onfinish = (e1:any) => {

        let data_time=dayjs().unix();

        setmarg_moban_modal_onfinish_select_log({message:'next_button',value:'',time:data_time})
        setmarg_moban_modal_onfinish_select_info({value1:e1,value2:'',value3:'',time:data_time})
    }


    const [return_data_marg_moban,setreturn_data_marg_moban]=useState({});

    const marg_moban_body = new FormData();


    marg_moban_body.append('finish_data', JSON.stringify(marg_moban_modal_onfinish_select_info.value1));

    marg_moban_body.append('userToken', String(Cookies.get('userToken_codegenerate')));

    marg_moban_body.append('time', String(marg_moban_modal_onfinish_select_info.time));

    marg_moban_body.append('action', 'add_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('undefined', {


                method: 'POST',
                body: marg_moban_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setmarg_moban_modal_open(false)

                    setreturn_data_marg_moban(return_data);
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break


            }

        }


        if(marg_moban_modal_onfinish_select_log.message!==''){

            data_async();
            setmarg_moban_modal_onfinish_select_log({message:'',value:'',time:0})
        }
    }, [marg_moban_modal_onfinish_select_log]);


    const copy_clip=(e1:any)=>{


      window.navigator.clipboard.writeText(e1)

        message.success('复制成功')
    }


    return(<div className="moban-page">

<Card className="moban-card" title="模板">
        <div className="moban-list">
            {return_data_fetch_moban.info.map(item=>{


                return(

                    <div className="moban-item" key={item.uuid}>

                            <Tooltip title={item.value}>
                                <div>

                                    <span className="moban-title">{item.title}</span>

                                    <span className="moban-meta">创建时间：{dayjs.unix(item.cretated).format('YYYY-MM-DD HH:mm:ss')}</span>




                                </div>
                            </Tooltip>

                            <Space size={4}>
                                <Tooltip title="使用"><SelectOutlined className="moban-icon-action" onClick={()=>{use_d(item.value)}}/></Tooltip>
                                <Tooltip title="编辑"><EditOutlined className="moban-icon-action" onClick={()=>{edit_moban(item.uuid,item.title,item.value,item.cretated)}}/></Tooltip>
                                <Tooltip title="删除"><DeleteOutlined className="moban-icon-action moban-icon-danger" onClick={()=>{del_moban(item.uuid)}}/></Tooltip>
                            </Space>
                    </div>
                )
            })}
        </div>



    </Card>

        <Card className="moban-card" title="变量">
            {moban_value.length>0?(    <div>

                <div>

                    <Form form={send_bianliang_modal_form} initialValues={send_bianliang_modal_initialValues} onValuesChange={send_bianliang_modal_onValuesChange} onFinish={send_bianliang_modal_onfinish}>





                        {moban_value.map(item=> (<div key={item}>

                            <Form.Item label={item} name={item} rules={[{message:'必填项',required:true}]} >

                                <Input>



                                </Input>


                            </Form.Item>


                        </div>))}



                        {/* <Button htmlType={'submit'} type={'primary'}>提交</Button>
                        <Button style={{marginLeft:10}} onClick={setsend_bianliang_modal_oncancel}>取消</Button>*/}

                    </Form>


                </div>






            </div>):<div className="moban-variable-empty">无变量信息</div>}
        </Card>


        <div className="moban-editor">




            <Card className="moban-card" title="变量内容">
            <Form form={select_message_modal_form} disabled initialValues={select_message_modal_initialValues} onFinish={select_message_modal_onfinish}>

                <Form.Item name={'input_value1'} rules={[{message:'必填项',required:true}]}>

                    <Input.TextArea className="moban-textarea">


                    </Input.TextArea>


                </Form.Item>




            </Form>
            </Card>



            {init_d_finish===''?<div></div>:  <Card className="moban-card" title={<div className="moban-panel-title"><span>输出</span><Tooltip title="复制"><CopyOutlined className="moban-icon-action" onClick={()=>copy_clip(init_d_finish)}/></Tooltip></div>}>

                <Input.TextArea className="moban-textarea" value={init_d_finish}/>


            </Card>}







        </div>



        <FloatButton.Group className="admin-float-actions">
            <FloatButton icon={<PlusOutlined/>} tooltip="创建模板" onClick={create_moban}/>
            <FloatButton icon={<ReloadOutlined/>} tooltip="刷新模板" onClick={() => setfetch_moban_select_log({message:'refresh', value:'', time:dayjs().unix()})}/>
        </FloatButton.Group>

        <Drawer open={marg_moban_modal_open} onClose={setmarg_moban_modal_oncancel} width={500} footer={null}>







        </Drawer>






        <Modal open={del_moban_modal_open} onCancel={setdel_moban_modal_oncancel} footer={null} title={'是否删除模板'}>


            <div className="moban-modal-actions">
                <Tooltip title="确认删除">
                    <Button danger icon={<DeleteOutlined/>} onClick={del_moban_modal_next_button}/>
                </Tooltip>
                <Tooltip title="取消">
                    <Button icon={<ClearOutlined/>} onClick={setdel_moban_modal_oncancel}/>
                </Tooltip>
            </div>


        </Modal>






        <Modal open={edit_moban_modal_open} onCancel={setedit_moban_modal_oncancel} footer={null} title={'编辑模板'}>




            <Form form={edit_moban_modal_form}  initialValues={edit_moban_modal_initialValues} onFinish={edit_moban_modal_onfinish}>

                <label>标题</label>

                <Form.Item name={'title'} rules={[{message:'必填项',required:true}]}>

                    <Input>



                    </Input>


                </Form.Item>

                <label>变量内容</label>

                <Form.Item name={'value'} rules={[{message:'必填项',required:true}]}>

                    <Input.TextArea style={{height: 200}}>



                    </Input.TextArea>


                </Form.Item>

                <div className="moban-modal-actions">
                    <Tooltip title="提交">
                        <Button htmlType={'submit'} type={'primary'} icon={<SelectOutlined/>}/>
                    </Tooltip>
                    <Tooltip title="取消">
                        <Button icon={<ClearOutlined/>} onClick={setedit_moban_modal_oncancel}/>
                    </Tooltip>
                </div>

            </Form>


        </Modal>




        <Modal open={create_moban_modal_open} onCancel={setcreate_moban_modal_oncancel} footer={null} title={'创建模板'}>




            <Form form={create_moban_modal_form} initialValues={create_moban_modal_initialValues} onFinish={create_moban_modal_onfinish}>

                <label>标题</label>

                <Form.Item name={'title'} rules={[{message:'必填项',required:true}]}>

                    <Input>



                    </Input>


                </Form.Item>

                <label>变量内容</label>

                <Form.Item name={'value'} rules={[{message:'必填项',required:true}]}>

                    <Input.TextArea style={{height: 200}}>



                    </Input.TextArea>


                </Form.Item>

                <div className="moban-modal-actions">
                    <Tooltip title="提交">
                        <Button htmlType={'submit'} type={'primary'} icon={<SelectOutlined/>}/>
                    </Tooltip>
                    <Tooltip title="取消">
                        <Button icon={<ClearOutlined/>} onClick={setcreate_moban_modal_oncancel}/>
                    </Tooltip>
                </div>

            </Form>


        </Modal>















    </div>)
}

export default Admin_moban_ui
